/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type CreateTeamMemberRequest = {
    confirmDefaultPassword?: string;
    defaultPassword?: string;
    email: string;
    firstName: string;
    lastName: string;
    outletIds?: Array<string>;
    phoneNumber: string;
    role: CreateTeamMemberRequest.role;
};

export namespace CreateTeamMemberRequest {

    export enum role {
        ADMIN = 'admin',
        MANAGER = 'manager',
        ACCOUNTANT = 'accountant',
        CASHIER = 'cashier',
    }


}

